<h5 class="title mb-4 text-primary">{{'identificacao'|translate}}</h5>

<div class="row g-4 mb-4" *ngIf="mdcService.err_connection_refused">
    <div class="nk-block nk-block-middle wide-lg mx-auto mt-4">
        <div class="nk-block-content nk-error-ld text-center">
            <img class="nk-error-gfx" style="max-width: 250px;" src="assets/images/gfx/error-504.svg" alt="">
            <div class="wide-xs mx-auto">
                <h4 class="nk-error-title">Gateway Timeout Error</h4>
                <p class="nk-error-text">We are very sorry for inconvenience. It looks like some how our server did not
                    receive a timely response.</p>
                <button (click)="mdcService.reloadForm()" class="btn btn-primary mt-2">Recarregar</button>
            </div>
        </div>
    </div>
</div>

<div class="row g-4 mb-4" *ngIf="!mdcService.err_connection_refused">
    <div *ngIf="mdcService.isLoading" class="card placeholder-glow mt-4" aria-hidden="true">
        <div class="card-body p-0">
            <p class="card-text placeholder-glow">
                <span class="placeholder col-9 mb-2"></span>
                <span class="placeholder bg-light col-4 py-3 mb-4"></span>
                <span class="placeholder bg-light col-4 py-3 ms-1 mb-4"></span>
                <span class="placeholder col-11 mb-2"></span>
                <span class="placeholder bg-light col-2 py-3"></span>
                <span class="placeholder bg-light col-2 py-3 ms-1"></span>
                <span class="placeholder col- mb-2"></span>
            </p>
        </div>
    </div>
    <div *ngIf="!mdcService.isLoading" class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('i_1')}}<span class="text-danger">&nbsp;*</span></label>
            
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.i1options">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input" id="i_1_{{item.id}}" #i_1="ngModel" name="i_1"
                            [(ngModel)]="mdcService.formData.i_1" required value="{{item.value}}"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)">
                        <label class="custom-control-label" for="i_1_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div *ngIf="!mdcService.isLoading" class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('i_2')}}<span class="text-danger">&nbsp;*</span></label>            
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input" id="i_2_{{item.id}}" #i_2="ngModel" name="i_2"
                            [(ngModel)]="mdcService.formData.i_2" value="{{item.value}}"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)" (change)="mdcService.onI2Change()"
                            required>
                        <label class="custom-control-label" for="i_2_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div *ngIf="mdcService.isVisible(['i_3'], mdcService.selectedI2Control, null)" class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4" for="I-3">{{mdcService.getLabelByCode('i_3')}}<span class="text-danger">&nbsp;*</span></label>
            
            <div class="form-control-wrap">
                <ng-select #i_3="ngModel" name="i_3" id="i_3" [(ngModel)]="mdcService.formData.i_3"
                    [items]="paisService.listPaisEstrangeiros" bindLabel="name" bindValue="id"
                    (change)="mdcService.onChangePais($event)" placeholder="{{'selct_msg'|translate}}" required>
                </ng-select>
                <span *ngIf="mdcService.formData.i_3! < 1" id="i_3_error_msg"
                    class="text-danger ff-italic fs-11px">{{'pais_res_error_msg'|translate}}</span>
            </div>
        </div>
    </div>
</div>